// Add your JS customizations here
;
(function ($) {
	'use strict'
	// const AJAX_URL = ajax_vars.rest_url;
	var theme = {
		init: () => {
			// theme.mapCarousel(),
			theme.owlCarousel(),
			theme.anchorNavigator(),
			theme.floatingLabels(),
			theme.smoothScroll(),
			theme.teamModal()
	},
		navbar: () => {
			if (window.scrollY > 100) {
				document.getElementById('main-nav').classList.add('fixed-top')
				let navbar_height = document.querySelector('.navbar').offsetHeight
				document.body.style.paddingTop = navbar_height + 'px'
			} else {
				document.getElementById('main-nav').classList.remove('fixed-top')
				document.body.style.paddingTop = '0'
			}
		},
		owlCarousel: () => {
			if ($('.owl-global-carousel').length) {
				var defaultOptions = {
					loop: false,
					nav: false,
					navText: [],
					autoplay: false,
					dots: true,
					margin: 10,
					responsive: {
						0: {
							items: 1
						}
					}
				}
				$('.owl-global-carousel').each(function (i, obj) {
					let options = $(obj).attr('data-options')
					let customOptions = defaultOptions
					if (options) {
						options = JSON.parse(options)
						customOptions = {
							...defaultOptions,
							...options,
						}
					}
					console.log(customOptions)
					$(obj).owlCarousel(customOptions)

					$(obj).on('translated.owl.carousel', function (event) {
						checkClasses(event.currentTarget)
					})
					checkClasses(obj)
				})

				function checkClasses(target) {
					$(target).find('.owl-item').removeClass('lastActiveItem')
					$(target).find('.owl-item').removeClass('firstActiveItem')
					let totalActive = $(target).find('.owl-item.active').length
					$(target)
						.find('.owl-item.active')
						.each(function (index) {
							if (index === totalActive - 1 && totalActive > 1) {
								$(this).addClass('lastActiveItem')
							}
							if (index === 0 && totalActive > 1) {
								$(this).addClass('firstActiveItem')
							}
						})
				}
			}
		},
		mapCarousel: () => {
			if ($('.dp-map-contents').length) {
				let $imagesDiv = $('.dp-map-images')
				let $prevControl = $('.card-navigation').find('.nav-prev')
				let $newtControl = $('.card-navigation').find('.nav-next')

				let $mapOwl = $('.dp-map-contents').owlCarousel({
					loop: false,
					nav: false,
					autoplay: false,
					dots: true,
					items: 1
				})
				$mapOwl.on('translated.owl.carousel', function (event) {
					$('.card-navigation > a').removeClass('disabled')
					if (event.item.count === event.item.index + 1) $newtControl.addClass('disabled')
					if (event.item.index === 0) $prevControl.addClass('disabled')
					$imagesDiv.find('.image').removeClass('active')
					$imagesDiv.find(`.image:eq(${event.item.index})`).addClass('active')
				})
				$prevControl.on('click', () => {
					$mapOwl.trigger('prev.owl.carousel');
				})
				$newtControl.on('click', () => {
					$mapOwl.trigger('next.owl.carousel');
				})
			}
		},
		anchorNavigator: () => {
			// Custom select
			$('.select-styled').each(function () {
				var $styledSelect = $(this)
				var $list = $(this).next("ul.select-options")
				var $listItems = $list.children("li")
				$styledSelect.click(function (e) {
					e.stopPropagation()
					$('div.select-styled.active')
						.not(this)
						.each(function () {
							$(this).removeClass("active").next("ul.select-options").hide()
						})
					$(this).toggleClass("active").next("ul.select-options").toggle()
				})

				$listItems.click(function (e) {
					e.stopPropagation()
					$styledSelect.text($(this).text()).removeClass("active")
					$list.hide()
					let anchor = $(this).attr('rel')
					$([document.documentElement, document.body]).animate({
						scrollTop: $(anchor).offset().top - $('.anchor-navigator').height()
					}, 500)
				})

				$(document).click(function () {
					$styledSelect.removeClass("active")
					$list.hide()
				})
			})
			// Anchor navigator
			$('.anchor-navigator:not(.no-scroll) .anchor-navigator__button-wrapper > a').on('click', function (e) {
				e.stopPropagation()
				let anchor = $(this).attr('href')
				if ($(anchor).length) {
					$([document.documentElement, document.body]).animate({
						scrollTop: $(anchor).offset().top - $('.anchor-navigator').height() - 150
					}, 500)
				}
			})
			var anchorNagivator = $('.anchor-navigator')
			if (anchorNagivator.length) {
				var sticky = $(anchorNagivator).offset().top - $('#main-nav').outerHeight()
				window.onscroll = function () {
					checkSticky()
					if (!$(anchorNagivator).hasClass('no-scroll')) checkActive()
				}
				window.onload = function () {
					checkSticky()
					if (!$(anchorNagivator).hasClass('no-scroll')) checkActive()
				}
				window.onresize = function () {
					$('.sticky').css('top', $('#main-nav').outerHeight())
				}
			}
			// Check Sticky
			function checkSticky() {
				if (window.pageYOffset >= sticky) {
					anchorNagivator.addClass('sticky')
					anchorNagivator.css('top', $('#main-nav').outerHeight())
					// Fix body padding top
					let currentPaddingTop = parseInt($('body').css('padding-top').replace('px', ''))
					let anchorHeight = anchorNagivator.outerHeight()
					$('body').css('padding-top', currentPaddingTop + anchorHeight + 'px')
				} else {
					anchorNagivator.removeClass('sticky')
					// document.body.style.paddingTop = '0'
				}
			}
			// On scroll
			// Bind to scroll
			function checkActive() {
				// Get container scroll position
				var fromTop = $(window).scrollTop() + $('#main-nav').outerHeight()
				var menuItems = $('.anchor-navigator').find('a')
				var scrollItems = menuItems.map(function () {
					var item = $($(this).attr("href"))
					if (item.length) {
						return item
					}
				});
				// Get id of current scroll item
				var cur = scrollItems.map(function () {
					if ($(this).offset().top - 150 < fromTop)
						return this
				})
				// Get the id of the current element
				cur = cur[cur.length - 1]
				var id = cur && cur.length ? cur[0].id : ""
				// Set/remove active class
				menuItems
					.removeClass("active")
					.filter("[href='#" + id + "']").addClass("active")
			}
		},
		floatingLabels: () => {
			//On input focus move the label
			$("input, textarea").on('focus', function () {
				$(this).parent().siblings("label").addClass("move")
			})

			//On focusout check if there is a value, else remove the .move class.
			$("input, textarea").on('focusout', function () {
				if ($(this).val().length == 0) {
					$(this).parent().siblings("label").removeClass("move")
				}
			})
			//If the user clicks on the label itself, activate the corresponding input.
			var labelID
			$('label').on('click', function () {
				labelID = $(this).attr('for')
				$('#' + labelID).trigger('click')
			});
			//In case there is a prefill value
			$("input, textarea").each(function () {
				if ($(this).val().length != 0) {
					$(this).parent().siblings("label").addClass("move")
				} else {
					$(this).parent().siblings("label").removeClass("move")
				}
			})
		},
		smoothScroll: () => {
			if ( window.location.hash ) {
				var hash = window.location.hash;
			
				if ($(hash).length) {
					$('html, body').animate({
						scrollTop: $(hash).offset().top - 150
					}, 900, 'swing');
				}
			}
		},
		teamModal: () => {
			let tm = document.getElementById('teamModal')
			if ( tm ) {
				$('.single-team-loop').on('click', e => {
					let $teamContent = $(e.currentTarget).find('.team-content').html();
					$('#teamModal').find('.modal-body').html($teamContent);
				})
				tm.addEventListener('hidden.bs.modal', function (event) {
					
				})
			}
		}
	}
	$(window).load(function () {
		theme.init()
		theme.navbar()
	})
	$(window).on('scroll', function () {
		theme.navbar()
	})
})(jQuery)